module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"viewDetail":"Ver detalhes","quantity":"Quantidade"},"en-US":{"viewDetail":"View details","quantity":"Quantity"}}')
  delete Component.options._Ctor
}
